export const getPurgeMinFee = (minfee: number) => {
	return Number((minfee * 100000).toFixed(2))
}
